import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { cityRecordQuery } from "@/app/Cities/Cities/GraphQL/cityRecordQuery";
import { useMatch } from "@tanstack/react-router";

export function useCityDrawer() {
  const match = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/admin/cities/$cityId",
  });

  const { data } = useSuspenseGqlQuery(cityRecordQuery, {
    id: match.params.cityId,
  });

  return data.city;
}
